module.exports = __webpack_public_path__ + "static/media/image-52.f7dd5e1d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar/img/image-52.svg
 ** module id = 2059
 ** module chunks = 0
 **/